// Personalized Ajax Request/Response handler for interacting with ElationEMR
// server.  Handles accepted failure codes.
//
// Created by: Josh Burnell, 7/26/10
(function($) {
    /**
     * Carries any sort of app-specific customization of how these ajax
     * wrappers work. There are two keys:
     *
     * 1. processResponseFn - called in any success or error callback,
     *      but not in error_override callbacks
     * 2. logoutFn - called in response to a 421 in error_override callbacks.
     *      Ideally, this is the same as processResponseFn's handling of 421s
     */
    jQuery.el8_ajaxOpts = {};
    /* Manage an ajax call to the Elation web service
     *   Takes identical options to jQuery.ajax with exceptions:
     *      error_override: method executed in lieu of standard el8_ajax error handling
     *      error_msg: message to be displayed in el8_ajax error alert
     *      error: method executed after standard el8_ajax error
     *                  handling; takes same input (i.e. XMLHttpRequest,
     *                  textStatus, errorThrown)
     *      isReadOnlyFetch: opt-in flag indicating this POST is a non-mutating
     *                  read-only fetch (e.g. a GET-equivalent forced to POST due
     *                  to URL length limits). Only set this at the call site
     *                  when you can guarantee the endpoint does not mutate
     *                  state. Required to allow a POST through in READ_ONLY mode.
     */
    jQuery.el8_ajax = function(options) {
        // Remove the Response dependent parameters
        var success_cb = options.success;
        var requestInfo = null;
        if (UIM) { requestInfo = { requestId : (new Date()).getTime(), url : options.url }; }
        // Need to add page session ID to every url
        options.data = options.data || {};
        if ((options.type !== 'DELETE') && (options.type !== 'POST')) {
            options.data['_ps'] = el8Globals['PAGE_SESSION_ID'];
        } else {
            options.url = addRequestParam(options.url, '_ps', el8Globals['PAGE_SESSION_ID']);
        }
        if (options.cache === undefined || options.cache === null) {
            options.cache = false;
        }
        options.success = generateSuccessProcessor(success_cb, requestInfo);
        if (options.error_override) {
            options.error = function(xhr, textStatus, data, err, msg, requestInfo) {
                // even for error_override, don't override the check for whether the user is logged in
                var logoutFn = jQuery.el8_ajaxOpts['logoutFn'];
                if (xhr && xhr.status === 421 && logoutFn) {
                    logoutFn();
                    return;
                }
                options.error_override.apply(jQuery, arguments);
            };
        } else {
            var error_cb = options.error;
            options.error = generateErrorProcessor(error_cb, options.error_msg, requestInfo);
        }
        options.jsonp = false;
        // Until a patch for jQuery1.5 comes out, never explicitly set dataType to "json"
        if (options.dataType && options.dataType.toLowerCase() === 'json') {
            delete options['dataType'];
        }
        if (el8Globals.READ_ONLY && options.type) {
            var type = options.type.toLowerCase();
            if (type === 'put' || type === 'delete') {
                // TODO: Show alert to user saying that no changes will be saved
                var fakeAjax = $.Deferred().promise(); // This promise will go unfulfilled
                fakeAjax.abort = function () {};
                return fakeAjax;
            }
            if (type === 'post' && !options.isReadOnlyFetch) {
                // Block POST requests in READ_ONLY mode unless the call site
                // has explicitly opted in via isReadOnlyFetch, indicating this
                // POST is a GET-equivalent (e.g. a bulk fetch forced to POST
                // because the URL would exceed length limits) and does not
                // mutate any data.
                var fakeAjax = $.Deferred().promise(); // This promise will go unfulfilled
                fakeAjax.abort = function () {};
                return fakeAjax;
            }
        }
        // Make Ajax call and test result
        return $.ajax(options);
    };
    /* A wrapper for a pair of AJAX calls for a long polling endpoint
     * This function expects a particular API design for these endpoints:
     *      1. A single URL with both a POST and a GET
     *      2. The POST sets up the async task and either returns data (if the
     *         task finishes quickly) or a celery task ID called `in_progress`
     *      3. The GET takes that ID as the key "task_id" and returns one of:
     *         - {pending: true} if the task is still running (client should poll again)
     *         - {error: ...} if the task failed
     *         - The actual result data when the task is complete
     *         For backwards compatibility, falsy responses (None/False) are also
     *         treated as "pending" and will trigger a retry.
     *
     * success: callback function, to run when the async task finishes; required
     * url: used for both the initial call and subsequent polls; required
     * data: submitted in the initial POST only; optional
     */
    jQuery.el8_longPoll = function(options) {
        if (!options.success) { return; } // longpolling is useless without this callback
        var asyncTaskId = null;
        var pollDelay = 1000; // Start polling at 1 second intervals
        var maxPollDelay = 10000; // Cap polling interval at 10 seconds

        var pollingFn = function() {
            $.el8_ajax({
                type: 'GET',
                url: options.url,
                data: { 'task_id': asyncTaskId }, // should have been set before calling
                success: function(data) {
                    // Task still pending - schedule retry with exponential backoff
                    if (!data || data.pending) {
                        setTimeout(pollingFn, pollDelay);
                        pollDelay = Math.min(Math.floor(pollDelay * 1.5), maxPollDelay);
                        return;
                    }
                    // Task failed - treat as error
                    if (data.error) {
                        if (options.error) {
                            options.error(null, 'error', data.error);
                        }
                        return;
                    }
                    // Task completed successfully
                    options.success(data, asyncTaskId);
                },
                error: options.error
            });
        };
        var postArgs = {
            type: 'POST',
            url: options.url,
            data: options.data || {},
            success: function(data) {
                if (data.in_progress) {
                    asyncTaskId = data.in_progress;
                    pollingFn();
                } else {
                    options.success(data, asyncTaskId);
                }
            },
            error: options.error
        };
        if (options.isFileUpload) {
            postArgs.contentType = false;
            postArgs.processData = false;
        }
        $.el8_ajax(postArgs);
    };
    /* DEPRECATED */
    // Wrapping jQuery.load()
    jQuery.fn.el8_load = function(url) {
        var container = this;
        return $.ajax({
            url: url,
            type: 'GET',
            async: false,
            success: function(data, textStatus, xhr) {
                // We do not call generateSuccessProcessor()
                // because we do not want the html to load
                // if user, for example, is not logged in.
                processResponse(xhr, textStatus, data);
                container.html(data); // XSS OK -KF (should be django template!!)
            },
            error: generateErrorProcessor()
        });
    };
    /**
     * ----------------------------------------
     * Helper functions for ajax handlers above
     * ----------------------------------------
     */
    // Process the Error Response code
    //   Variables:
    //      msg: error message passed from jQuery.el8_ajax:error_msg
    // Case statement should be written to account for response codes
    function processResponse(xhr, textStatus, data, err, msg, requestInfo) {
        /* Can be over-ridden by setting ajaxOpts */
        var fn = jQuery.el8_ajaxOpts['processResponseFn'] || function() {};
        fn.apply(jQuery, arguments);
    }
    // Return the adjusted Error Callback
    function generateErrorProcessor(callback, msg, requestInfo) {
        return function(xhr, textStatus, err) {
            processResponse(xhr, textStatus, null, err, msg, requestInfo);
            if (callback) { callback(xhr, textStatus, err); }
        };
    }
    // Return the adjust Success Callback
    function generateSuccessProcessor(callback, requestInfo) {
        return function(data, textStatus, xhr) {
            processResponse(xhr, textStatus, data);
            if (callback) {
                try {
                    callback(data, textStatus, xhr);
                } catch(ex) {
                    var msg = 'ajax success callback error: ' + ex;
                    if (ex.stack) {
                        msg += '\n\n' + ex.stack;
                    }
                    if (UIM) {
                        UIM.logError(msg, ex);
                    } else {
                        console.log(msg);
                    }
                }
            }
        };
    }
    // Add's a param to the URL, safely... notices if there's already one and does ? vs & stuff.
    function addRequestParam(url, name, value) {
        var paramString = name + '=' + value;
        if (url.indexOf('?') >= 0) {
            return url + '&' + paramString;
        }
        else {
            return url + (!url.endswith('/') ? '/' : '') + '?' + paramString;
        }
    }
    // Helper method to retrieve a cookie value. Only external dependency is jQuery
    // This is necessary to get the value of the csrftoken cookie, which we need
    // to include in all state mutating requests. Borrowed from:
    // https://docs.djangoproject.com/en/1.11/ref/csrf/#ajax
    //
    // N.B. This method is used in a couple other places, so if you remove it,
    // be sure to search the code for 'getCookie' and fix those calls.
    jQuery.getCookie = function(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
    // Set up CSRF handling
    function csrfSafeMethod(method) {
        // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }
    jQuery.ajaxSetup({
        beforeSend: function(xhr, settings) {
            if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                xhr.setRequestHeader("X-CSRFToken", jQuery.getCookie('csrftoken'));
            }
        }
    });
})(jQuery);
